import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './Pages.css';
import SEOMetaTags from '../common/SEOMetaTags';

const Blog = () => {
  // Sample blog posts data
  const blogPosts = [
    {
      id: 1,
      title: 'How to Choose the Perfect Diamond',
      excerpt: 'Learn about the 4Cs of diamonds and how to select the perfect diamond for your special occasion.',
      image: 'https://images.unsplash.com/photo-1600267185393-e158a98703de?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      date: 'March 10, 2024',
      author: 'Rahul Sharma',
      category: 'Buying Guide'
    },
    {
      id: 2,
      title: 'The History of Diamond Jewelry',
      excerpt: 'Explore the fascinating history of diamond jewelry from ancient civilizations to modern times.',
      image: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      date: 'February 25, 2024',
      author: 'Priya Patel',
      category: 'Education'
    },
    {
      id: 3,
      title: 'Diamond Jewelry Care and Maintenance',
      excerpt: 'Tips and tricks to keep your diamond jewelry sparkling and beautiful for generations to come.',
      image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      date: 'February 15, 2024',
      author: 'Amit Verma',
      category: 'Care Guide'
    },
    {
      id: 4,
      title: 'Engagement Ring Trends for 2024',
      excerpt: 'Discover the latest trends in engagement ring designs that are captivating couples this year.',
      image: 'https://images.unsplash.com/photo-1589674781759-c21c37956a44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      date: 'January 30, 2024',
      author: 'Neha Gupta',
      category: 'Trends'
    },
    {
      id: 5,
      title: 'Ethical Diamond Sourcing',
      excerpt: 'Learn about how NM Diamond ensures ethical sourcing of all our diamonds and gemstones.',
      image: 'https://images.unsplash.com/photo-1611955167811-4711904bb9f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      date: 'January 15, 2024',
      author: 'Vikram Singh',
      category: 'Sustainability'
    },
    {
      id: 6,
      title: 'Custom Jewelry Design Process',
      excerpt: 'A behind-the-scenes look at how our artisans create custom jewelry pieces for our clients.',
      image: 'https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      date: 'December 20, 2023',
      author: 'Ananya Desai',
      category: 'Design'
    }
  ];

  return (
    <>
      <SEOMetaTags 
        title="Diamond Jewelry Blog | Expert Tips & Trends"
        description="Explore NM Diamond's blog for expert insights on diamond jewelry, care tips, latest trends, ethical sourcing, and custom design processes. Stay informed with our jewelry experts."
        keywords="diamond blog, jewelry trends, diamond care, ethical diamonds, custom jewelry design, engagement ring trends, diamond buying guide"
        canonicalUrl="https://www.nmdiamond.in/blog"
        ogImage="https://images.unsplash.com/photo-1600267185393-e158a98703de?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80"
      />
      <Container className="page-container">
        <Row className="page-header">
          <Col>
            <h1>Blog</h1>
          </Col>
        </Row>
        
        <Row className="page-content">
          <Col>
            <p className="blog-intro">
              Welcome to the NM Diamond blog, where we share insights, tips, and stories about diamonds, 
              jewelry, and the latest trends in the industry. Explore our articles to learn more about 
              the fascinating world of diamonds and jewelry craftsmanship.
            </p>
          </Col>
        </Row>
        
        <div className="blog-posts">
          <Row>
            {blogPosts.map(post => (
              <Col md={4} key={post.id} className="mb-4">
                <Card className="blog-card h-100">
                  <Card.Img variant="top" src={post.image} alt={post.title} className="card-img-top" />
                  <Card.Body>
                    <div className="blog-meta">
                      <span className="blog-category">{post.category}</span>
                      <span className="blog-date">{post.date}</span>
                    </div>
                    <Card.Title>{post.title}</Card.Title>
                    <Card.Text>{post.excerpt}</Card.Text>
                  </Card.Body>
                  <Card.Footer className="bg-transparent border-0">
                    <div className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">By {post.author}</small>
                      <Button className="btn-glow" size="sm">Read More</Button>
                    </div>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
        
        <Row className="mt-4 mb-5">
          <Col className="text-center">
            <Button className="btn-glow">Load More Articles</Button>
          </Col>
        </Row>
        
        <div className="newsletter-section">
          <Row>
            <Col md={8} className="mx-auto text-center">
              <h3>Subscribe to Our Newsletter</h3>
              <p className='newsletter-section p'>Stay updated with our latest articles, news, and special offers. Join our community of diamond enthusiasts.</p>
              <div className="d-flex justify-content-center">
                <div className="input-group mb-3" style={{ maxWidth: '500px' }}>
                  <input type="email" className="form-control" placeholder="Your Email Address" aria-label="Email Address" />
                  <Button className="btn-glow" id="button-addon2">Subscribe</Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Blog; 